document.addEventListener('DOMContentLoaded', function () {
    const criteria = [
      {
        title: '12 characters long',
        test: (password) => password.length >= 12,
      },
      {
        title: '1 uppercase letter',
        test: (password) => /[A-Z]/.test(password),
      },
      {
        title: '1 lowercase letter',
        test: (password) => /[a-z]/.test(password),
      },
      {
        title: '1 number',
        test: (password) => /\d/.test(password),
      },
      {
        title: '1 special character',
        test: (password) => /[@$!%?#^()&]/.test(password),
      },
    ];
  
    const submitButton = document.getElementById('submit-button');
    const errorDisplayP = document.querySelector("#password-error");
    const strengthCriteria = document.getElementById('strength-criteria');
    const pwInput = document.querySelector('#register_password');
    const emailInput = document.getElementById('register_email');
    const emailErrorDisplay = document.getElementById('email-error');
    const firstNameInput = document.getElementById('register_first_name');
    const lastNameInput = document.getElementById('register_last_name');
  
    // Email validation function
    function validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(String(email).toLowerCase());
    }
  
    // Function to check password and display the first unmet requirement
    function validatePasswordRealTime(password) {
      const firstUnmetCriterion = criteria.find(criterion => !criterion.test(password));
  
      // Display the first unmet criterion or hide if all are met
      if (firstUnmetCriterion) {
        strengthCriteria.innerHTML = firstUnmetCriterion.title;
        errorDisplayP.style.display = "block";
        submitButton.disabled = true;
        return false;
      } else {
        errorDisplayP.style.display = "none";
        submitButton.disabled = false;
        return true;
      }
    }
  
    // Real-time password validation
    pwInput.addEventListener('input', () => {
      validatePasswordRealTime(pwInput.value);
    });
  
    // Real-time email validation
    emailInput.addEventListener('input', () => {
      if (!validateEmail(emailInput.value)) {
        emailErrorDisplay.style.display = "block";
        emailErrorDisplay.innerHTML = "Please enter a valid email address.";
        submitButton.disabled = true;
      } else {
        emailErrorDisplay.style.display = "none";
        submitButton.disabled = false;
      }
    });
  
    // Form submit validation
    submitButton.addEventListener('click', function (e) {
      const registerPassword = pwInput.value;
      const registerEmail = emailInput.value;
      const firstName = firstNameInput.value;
      const lastName = lastNameInput.value;
      let errorMessage = '';
  
      // Check if any input field is empty
      if (!firstName || !lastName || !registerEmail || !registerPassword) {
        errorMessage = 'Please fill out all required fields.';
      }
      // Final password validation
      else if (!validatePasswordRealTime(registerPassword)) {
        errorMessage = 'Password does not meet the required criteria.';
      } 
      // Email validation before submission
      else if (!validateEmail(registerEmail)) {
        errorMessage = 'Please enter a valid email address.';
      }
  
      // If there's an error, show an alert and prevent form submission
      if (errorMessage) {
        e.preventDefault();
        alert(errorMessage);
      }
    });
  });